import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { accountFromLocalStorage } from '../../../../../old-crazy-web-frontend/src/app/utils/account-from-localstorage';
var CrazyCallConfigService = /** @class */ (function () {
    function CrazyCallConfigService(http, appConfigService) {
        this.http = http;
        this.appConfigService = appConfigService;
    }
    Object.defineProperty(CrazyCallConfigService.prototype, "authToken", {
        get: function () {
            var token = localStorage.getItem('ngStorage-authToken');
            return token ? token.replace(/\"/g, '') : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CrazyCallConfigService.prototype, "account", {
        get: function () {
            var account = accountFromLocalStorage();
            return account ? account.replace(/\"/g, '') : this.appConfigService.APP_ID;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CrazyCallConfigService.prototype, "appId", {
        get: function () {
            return this.account;
        },
        enumerable: true,
        configurable: true
    });
    CrazyCallConfigService.prototype.getProjects = function () {
        return this.http.get("/projects");
    };
    return CrazyCallConfigService;
}());
export { CrazyCallConfigService };
